<mat-tab-group
  [selectedIndex]="activeLabel"
  (selectedTabChange)="onTabChange($event)"
  mat-align-tabs="center">
  <mat-tab
    *ngFor="let label of labels; let index = index"
    label="{{ label.translated }}"></mat-tab>
</mat-tab-group>
